/**
 * @fileoverview Decodifica o payload de um JWT sem validar assinatura — só pra
 * ler claims que o frontend precisa (ex.: o bloco `impersonation`, a finalidade
 * `onboarding` da sessão de quem ainda não tem conta). Validação de fato fica
 * no backend via isAuth middleware.
 */

const decodeJwtPayload = (token) => {
  if (!token) return null;
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    // Base64URL → Base64 padding + decode
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
};

/**
 * A sessão de quem entrou e ainda não tem conta (a finalidade `onboarding` do
 * token guardado): só a esteira de cadastro vale nela, e o que pede a conta
 * (filas, progresso, cobrança) nem é buscado.
 */
export const isOnboardingSession = () => decodeJwtPayload(localStorage.getItem("token"))?.purpose === "onboarding";

export default decodeJwtPayload;
